<template>
  <div class="main-content-container full-bg">
    <h6
      class="font-sm breadcrumb--light ml-3 text-uppercase font-family-medium"
    ></h6>
    <h1 class="font-lg font-family-medium primary-dark content-title">
      Profile
    </h1>

    <!-- Start skeleton loader -->
    <div class="d-flex mt-5" v-if="loading">
      <div class="general-info-form-group col-md-6">
        <ValidationObserver>
          <b-form-group
            class="
              d-flex
              font-family-regular
              primary-dark
              mb-5
              w-100
              profile-settings-general-info
              full-width-form
            "
            label="General info"
          >
            <b-card class="d-flex flex-column general-info-card w-100">
              <div class="d-flex flex-wrap mt-2">
                <b-row class="w-100 my-0 mx-auto mb-4" align-v="center">
                  <b-col md="3" class="px-0 ml-3">
                    <b-skeleton type="avatar" size="11rem"></b-skeleton>
                  </b-col>
                  <b-col md="6">
                    <b-skeleton width="80%"></b-skeleton>
                    <b-skeleton class="mt-3" width="70%"></b-skeleton>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-2" md="6">
                    <ValidationProvider
                      name="First Name field"
                      rules="required"
                    >
                      <b-form-group label="First name *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col class="mb-2" md="6">
                    <ValidationProvider name="Last Name field" rules="required">
                      <b-form-group label="Last Name*">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <ValidationObserver ref="accountSettings">
          <b-form-group
            class="d-flex font-family-regular primary-dark mb-5 full-width-form"
            label="Reset Password"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <b-form-group label="Email">
                      <b-skeleton type="input" height="4rem"></b-skeleton>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider>
                      <b-form-group label="Old Password">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto flex-wrap">
                  <b-col class="mb-5">
                    <ValidationProvider>
                      <b-form-group label="New Password">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-2">
                    <ValidationProvider>
                      <b-form-group label="Confirm new password">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <ValidationObserver ref="communicationInfo">
          <b-form-group
            class="d-flex font-family-regular primary-dark full-width-form"
            label="Communication platforms"
          >
            <b-card class="d-flex flex-column general-info-card mb-5">
              <div class="d-flex flex-wrap">
                <b-row
                  v-for="index in 2"
                  :key="index"
                  class="w-100 mb-4 mt-2 mx-auto d-flex align-items-center"
                >
                  <b-col md="1" class="mr-4">
                    <div class="communication-icons mr-4">
                      <b-skeleton type="avatar" size="4.4rem"></b-skeleton>
                    </div>
                  </b-col>
                  <b-col md="4">
                    <b-skeleton width="75%" class="ml-3"></b-skeleton>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <b-skeleton type="input" height="4rem"></b-skeleton>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
      </div>
      <!-- End left column form -->

      <!-- Right column form -->
      <div class="general-info-form-group col-6">
        <ValidationObserver ref="employmentSettings">
          <b-form-group
            v-if="role === 'assistant'"
            class="d-flex font-family-regular primary-dark mb-5"
            label="Employment settings"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider>
                      <b-form-group label="Work hours per week *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider>
                      <b-form-group label="Employment type*">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 mx-auto">
                  <b-col md="12">
                    <ValidationProvider>
                      <b-form-group label="Date of Joining*">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto mt-5">
                  <b-col class="mb-2">
                    <ValidationProvider>
                      <b-form-group label="Specialities *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <ValidationObserver ref="addressInfo">
          <b-form-group
            class="d-flex font-family-regular primary-dark mb-5"
            label="Address info"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5 mt-1" md="6">
                    <ValidationProvider>
                      <b-form-group label="Country">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col class="mb-5 mt-2" md="6">
                    <ValidationProvider>
                      <b-form-group label="City *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider>
                      <b-form-group label="Street number *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider>
                      <b-form-group label="Street name *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-2">
                    <ValidationProvider>
                      <b-form-group label="Zip code *">
                        <b-skeleton type="input" height="4rem"></b-skeleton>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <b-form-group
          v-if="role !== 'owner'"
          label="Email notifications settings"
        >
          <b-card class="d-flex flex-column general-info-card">
            <div class="d-flex flex-wrap">
              <b-row class="w-100 my-0 mx-auto" v-for="index in 5" :key="index">
                <b-col class="mb-4" md="10">
                  <b-skeleton height="2rem" width="85%"></b-skeleton>
                </b-col>
                <b-col class="mb-4 d-flex justify-content-end" md="2">
                  <b-skeleton
                    type="avatar"
                    width="2rem"
                    height="2rem"
                    class="ml-4"
                  ></b-skeleton>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-form-group>
      </div>
    </div>
    <!-- End skeleton loader -->

    <b-row class="d-flex mt-5" v-else>
      <b-col class="general-info-form-group" cols="12" md="6">
        <ValidationObserver ref="generalInfo">
          <b-form-group
            class="d-flex font-family-regular primary-dark mb-5 full-width-form"
            label="General info"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap mt-2">
                <b-row class="w-100 my-0 mx-auto mb-4" align-v="center">
                  <b-col md="3" class="px-0 ml-3">
                    <b-avatar
                      v-if="avatar"
                      :src="avatar"
                      size="11rem"
                    ></b-avatar>
                    <b-avatar
                      v-else
                      :text="avatarName"
                      class="bg--primary"
                      size="11rem"
                    ></b-avatar>
                  </b-col>
                  <b-col md="6">
                    <label
                      class="
                        font-sm
                        file-select
                        mt-3
                        cursor-pointer
                        action-text
                      "
                    >
                      <p class="secondary--text">Click to upload/update</p>
                      <p class="secondary--text reduce-whitespace">
                        profile picture *
                      </p>
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        @click="uploadClear"
                        @change="uploadFile"
                      />
                    </label>
                    <h6
                      v-if="photoFileTypeError"
                      class="
                        font-sm font-family-regular
                        position-relative
                        danger
                      "
                    >
                      Incorrect file type. Please upload an image.
                    </h6>
                    <h6
                      v-if="!photoUpdated"
                      class="
                        font-sm font-family-regular
                        position-relative
                        danger
                      "
                    >
                      Please update profile picture
                    </h6>
                    <h6
                      v-if="photoTokenError"
                      class="
                        font-sm font-family-regular
                        position-relative
                        danger
                      "
                    >
                      User token expired. Please logout and login again.
                    </h6>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-2" md="6">
                    <ValidationProvider
                      name="First Name field"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="First name *">
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          type="text"
                          v-model="firstName"
                          placeholder="Enter first name"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col class="mb-2" md="6">
                    <ValidationProvider
                      name="Last Name field"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Last name *">
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          type="text"
                          v-model="lastName"
                          placeholder="Enter last name"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <ValidationObserver ref="accountSettings">
          <b-form-group
            class="d-flex font-family-regular primary-dark mb-5"
            label="Reset Password"
          >
            <div class="mt-2" v-if="showPasswordError">
              <li v-for="error in errorAccountSetting" :key="error.message">
                <h6
                  style="margin-top: 0.2rem"
                  class="
                    font-sm font-family-regular
                    danger
                    position-relative
                    mb-2
                  "
                >
                  {{ error }}
                </h6>
              </li>
            </div>
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5 mt-1">
                    <b-form-group label="Email">
                      <b-form-input
                        autocomplete="off"
                        size="lg"
                        :disabled="true"
                        type="text"
                        v-model="email"
                        placeholder
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider
                      name="Password"
                      rules=""
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Old password">
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          v-model="oldPassword"
                          type="password"
                          placeholder="Enter password"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto flex-wrap">
                  <b-col class="mb-5">
                    <ValidationProvider
                      name="newPassword"
                      rules="customPassword|required"
                      v-slot="{ errors }"
                      vid="newPassword"
                    >
                      <b-form-group label="New password">
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          v-model="newPassword"
                          type="password"
                          vid="newPassword"
                          placeholder="Enter new password"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-2">
                    <ValidationProvider
                      name="confirmPassword"
                      rules="password:@newPassword|required"
                      vid="confirmPassword"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Confirm new password">
                        <b-form-input
                          autocomplete="off"
                          v-model="confirmPassword"
                          size="lg"
                          type="password"
                          placeholder="Enter new password"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <ValidationObserver ref="communicationInfo">
          <b-form-group
            class="d-flex font-family-regular primary-dark full-width-form"
            label="Communication platforms"
          >
            <b-card no-body class="d-flex flex-column general-info-card mb-5">
              <b-card-body>
                <div class="d-flex flex-wrap">
                  <b-row
                    v-for="item in communicationsListTwo"
                    :key="item.id"
                    class="
                      communications-row
                      d-flex
                      align-items-center
                      nowrap
                      w-125
                    "
                  >
                    <b-col md="4">
                      <div
                        class="
                          communication-icons
                          mr-4
                          d-flex
                          align-items-center
                        "
                      >
                        <img
                          class="position-relative ml-2 reduce-whitespace-2"
                          :src="item.communication.mediumThumbnail"
                          alt
                        />
                        <p
                          :class="[
                            item.communication.medium === 'Secondary Email' ||
                            item.communication.medium === 'Cell phone'
                              ? 'reduce-line-height'
                              : null,
                          ]"
                          class="ml-5 font-weight-normal"
                        >
                          {{ item.communication.medium }}
                        </p>
                      </div>
                    </b-col>

                    <b-col
                      md="8"
                      class="communications-textbox position-absolute pr-5"
                    >
                      <b-form-group>
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          type="text"
                          placeholder="N/A"
                          v-model="item.value"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <ValidationObserver ref="employmentSettings">
          <b-form-group
            v-if="role === 'assistant'"
            class="d-flex font-family-regular primary-dark mb-5"
            label="Employment settings"
          >
            <div v-if="showEmploymenterror" class="mt-2">
              <li v-for="error in errorEmploymentSetting" :key="error.message">
                <h6
                  style="margin-top: 0.2rem"
                  class="
                    font-sm font-family-regular
                    danger
                    position-relative
                    mb-2
                  "
                >
                  {{ error }}
                </h6>
              </li>
            </div>
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 mx-auto">
                  <b-col class="mb-5 md-6">
                    <ValidationProvider
                      name="Date of joining field"
                      rules="required|date"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Date of joining *">
                        <b-input-group>
                          <b-form-input
                            v-model="doj"
                            type="text"
                            placeholder="YYYY-MM-DD"
                            autocomplete="off"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              v-model="doj"
                              style="z-index:1"
                              button-only
                              :show-decade-nav="true"
                              right
                              class="datepicker"
                              locale="en-US"
                              aria-controls="example-input"
                              @context="onContext"
                            >
                              <template #button-content="">
                                <img
                                  src="@/assets/icons/date-picker.svg"
                                  alt=""
                                />
                              </template>
                            </b-form-datepicker>
                          </b-input-group-append>
                        </b-input-group>
                        <h6
                          v-if="errors[0]"
                          class="font-sm font-family-regular position-relative danger profile-err"
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col class="mb-5 md-6">
                    <ValidationProvider
                      name="Working hours field"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Work hours per week *">
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          type="text"
                          v-model="workHours"
                          placeholder="Enter work hours"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err-3
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider
                      name="Employment type field"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Employment type *">
                        <b-form-select
                          v-model="selectedEmploymentType"
                          :options="employmentTypes"
                          @change="selectedDays = []"
                        ></b-form-select>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row
                  class="w-100 mx-auto"
                  v-if="selectedEmploymentType === 'PART'"
                >
                  <b-col class="mb-5">
                    <ValidationProvider
                      name="Unavailable days field"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Days Unavailable *">
                        <multiselect
                          placeholder="Select Days"
                          v-model="selectedDays"
                          label="text"
                          track-by="id"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          class="custom-multiselect mb-3 categories-multiselect"
                          :options="availabilityDays"
                          :multiple="true"
                        >
                          <template slot="noResult"
                            >No Day found</template
                          ></multiselect
                        >
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 mx-auto">
                  <b-col md="12">
                    <ValidationProvider
                      name="Date of joining field"
                      rules="required|date"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Date of joining *">
                        <b-input-group>
                          <b-form-input
                            v-model="doj"
                            type="text"
                            placeholder="YYYY-MM-DD"
                            autocomplete="off"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-datepicker
                              v-model="doj"
                              style="z-index: 1"
                              button-only
                              :show-decade-nav="true"
                              right
                              class="datepicker"
                              locale="en-US"
                              aria-controls="example-input"
                              @context="onContext"
                            >
                              <template #button-content="">
                                <img
                                  src="@/assets/icons/date-picker.svg"
                                  alt=""
                                />
                              </template>
                            </b-form-datepicker>
                          </b-input-group-append>
                        </b-input-group>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- <b-col class="mb-4" md="6">
                      <ValidationProvider
                        name="Profile type"
                        rules="required"
                        v-if="role !== 'assistant'"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Profile type">
                          <b-form-select v-modeml="selectedProfileType" :options="profileTypes"></b-form-select>
                          <h6 class="font-family-regular position-absolute danger">{{ errors[0] }}</h6>
                        </b-form-group>
                      </ValidationProvider>
                  </b-col>-->
                </b-row>
                <b-row class="w-100 mt-5 my-0 mx-auto">
                  <b-col class="mb-2">
                    <ValidationProvider
                      name="Specialities field"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Specialities *">
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          type="text"
                          v-model="specialities"
                          placeholder="Enter specialities"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
      </b-col>
      <!-- End left column form -->

      <!-- Right column form -->
      <b-col class="general-info-form-group" cols="12" md="6">
        <ValidationObserver ref="addressInfo">
          <b-form-group
            class="d-flex font-family-regular primary-dark mb-5"
            label="Address info"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5 mt-2" md="6">
                    <b-form-group label="Country *">
                      <ValidationProvider
                        name="Country"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <multiselect
                          placeholder="Select country"
                          v-model="selectedCountry"
                          label="text"
                          track-by="id"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          hideSelected
                          class="custom-multiselect countries-multiselect"
                          :options="countries"
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ ellipsify(option.text, 20) }}
                          </template>
                          <template slot="noResult"
                            >No countries found</template
                          ></multiselect
                        >
                        <h6
                          class="
                            font-sm
                            mb-3
                            font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-5 mt-2" md="6">
                    <ValidationProvider
                      name="City field"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="City *">
                        <b-form-input
                          v-model="selectedCity"
                          placeholder="Enter city name"
                          type="text"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-relative
                            danger
                            profile-err
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider
                      name="Address Line 1"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Address Line 1 *">
                        <b-form-input
                          placeholder="Enter address."
                          v-model="streetName"
                        ></b-form-input>
                      </b-form-group>
                      <h6
                        v-if="errors[0]"
                        class="
                          font-sm font-family-regular
                          position-relative
                          danger
                          profile-err-2
                        "
                      >
                        {{ errors[0] }}
                      </h6>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-5">
                    <ValidationProvider
                      name="Address line 2"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Address line 2 *">
                        <b-form-input
                          placeholder="Enter another address"
                          v-model="streetNumber"
                        ></b-form-input>
                      </b-form-group>
                      <h6
                        v-if="errors[0]"
                        class="
                          font-sm font-family-regular
                          position-relative
                          danger
                          profile-err-2
                        "
                      >
                        {{ errors[0] }}
                      </h6>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row class="w-100 my-0 mx-auto">
                  <b-col class="mb-2">
                    <ValidationProvider
                      name="Postal Code"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group label="Zip code *">
                        <b-form-input
                          placeholder="Enter Zip Code"
                          v-model="postalCode"
                        ></b-form-input>
                      </b-form-group>
                      <h6
                        v-if="errors[0]"
                        class="
                          font-sm font-family-regular
                          position-relative
                          danger
                          profile-err-2
                        "
                      >
                        {{ errors[0] }}
                      </h6>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <b-form-group
          v-if="role !== 'owner'"
          class="d-flex font-family-regular primary-dark"
          label="Email notifications settings"
        >
          <b-card class="d-flex flex-column general-info-card" no-body>
            <b-card-body class="notif-card-body">
              <div class="d-flex flex-wrap">
                <b-row
                  class="w-100 my-0 mx-auto notif-card-row"
                  v-for="notification in notificationsListTwo"
                  :key="notification.id"
                >
                  <b-col
                    class="notif-checkbox custom-control custom-switch"
                    md="10"
                  >
                    <p>{{ notification.notification.title }}</p>
                  </b-col>
                  <b-col
                    class="
                      notif-checkbox
                      custom-control custom-switch
                      d-flex
                      justify-content-end
                    "
                    md="2"
                  >
                    <b-form-checkbox
                      switch
                      size="lg"
                      v-model="notification.isSelected"
                    ></b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
          </b-card>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mx-0 ml-3">
      <b-alert
        v-if="showValidity && role === 'assistant' && !loading"
        :show="showValidity && role === 'assistant' && !loading"
        class="alert-btn-top custom-alert"
      >
        <p class="ml-3">There are invalid form fields</p>
      </b-alert>
    </b-row>
    <b-row
      class="mx-0 ml-3"
      v-if="totalApiCalls.length === 6 && role === 'assistant' && !loading"
    >
      <b-col>
        <b-alert
          class="alert-btn-top custom-alert"
          v-if="totalApiCalls.length === passedApiCalls.length"
          :show="totalApiCalls.length === passedApiCalls.length"
        >
          <p>Profile saved successfully</p>
        </b-alert>
        <b-alert
          v-if="totalApiCalls.length !== passedApiCalls.length"
          :show="totalApiCalls.length !== passedApiCalls.length"
          class="alert-btn-top custom-alert"
        >
          <p v-if="tokenError">
            User token expired. Please logout and login again.
          </p>
          <p v-else>Some error occured</p>
        </b-alert>
      </b-col>
    </b-row>
    <b-row class="mx-0 ml-3">
      <b-alert
        v-if="showValidity && (role === 'admin' || role === 'owner') && !loading"
        :show="showValidity && (role === 'admin' || role === 'owner') && !loading"
        class="alert-btn-top custom-alert"
      >
        <p class="ml-3">There are invalid form fields</p>
      </b-alert>
    </b-row>
    <b-row
      class="mx-0 ml-3"
      v-if="totalApiCalls.length === expectedSaveCallCount && (role === 'admin' || role === 'owner') && !loading"
    >
      <b-alert
        v-if="totalApiCalls.length === passedApiCalls.length"
        :show="totalApiCalls.length === passedApiCalls.length"
        class="alert-btn-top custom-alert"
      >
        <p>Profile saved successfully</p>
      </b-alert>
      <b-alert
        v-if="totalApiCalls.length !== passedApiCalls.length"
        :show="totalApiCalls.length !== passedApiCalls.length"
        class="alert-btn-top custom-alert"
      >
        <p class="ml-3" v-if="tokenError">
          User token expired. Please logout and login again.
        </p>
        <p class="ml-3" v-else>Some error occured</p>
      </b-alert>
    </b-row>
    <div class="save-button-row">
      <b-button
        v-if="!loading"
        class="btn-pill px-5 py-3"
        @click.prevent="saveAll"
      >
        <b-spinner
          v-if="pageLoading"
          style="width: 14px; height: 14px"
          variant="light"
          label="Spinning"
        ></b-spinner>
        {{ `${!pageLoading ? "Save" : ""}` }}
      </b-button>
    </div>
    <b-modal
      centered
      no-close-on-esc
      hide-header
      hide-footer
      no-close-on-backdrop
      title="Upload Profile Picture"
      v-model="showCropper"
    >
      <b-container fluid>
        <div>
          <p>Upload Image</p>
        </div>
        <div>
          <img
            id="image"
            :src="fileURL"
            ref="source"
            class="cropper-hidden w-100"
          />
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="!cropperLoading"
            class="btn-cancel btn-primary px-5 py-3 btn-pill mt-3 mb-3"
            @click.prevent="resetModal"
          >
            Cancel
          </b-button>
          <b-button
            class="btn-cancel px-5 py-3 btn-pill mt-3 mb-3"
            @click.prevent="submitImage"
            :disabled="cropperLoading"
          >
            <b-spinner
              v-if="cropperLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!cropperLoading ? "Save" : ""}` }}
          </b-button>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import Cropper from "cropperjs";
import {
  getProfile,
  postCommunications,
  changePassword,
  getEmploymentSettings,
  getCommunicationIDs,
  postEmploymentSettings,
  getNotificationIDs,
  patchCommunications,
  postAddress,
  patchAddress,
  patchAvatar,
  postName,
  getAddress,
  getCommunications,
  getNotifications,
  postNotifications,
  patchNotifications
} from "@/apis/auth/index";
import { getAssistantDetails } from "@/apis/assistants/index";
import {
  countriesListJSON,
  ACCEPTED_IMAGE_FILE_TYPES
} from "@/utils/constants";
import { ellipsify, beforeRouteLeave, isOwner } from "@/utils/utils";
// import { getAllCountries } from "@/apis/common";
extend("required", {
  message: () => "This is a required field"
});
extend("integer", {
  message: () => "Street number can only contain numbers"
});
extend("alpha_spaces", {
  message: () => "Street name can only contain alphFabets"
});
let dateMessage;
extend("date", {
  message: () => dateMessage,
  validate: value => {
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      dateMessage = "YYYY-MM-DD format required";
      return false;
    }
  }
});
let generalErrorMessage = "This field can only contain alphabets";
extend("name", {
  message: () => `${generalErrorMessage}`,
  validate: value => {
    let mustContainTheseChars = /^[a-zA-Z ]*$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      generalErrorMessage = "This field can only contain alphabets";
      return false;
    }
  }
});
let passwordMatchMessage = "Passwords do not match";
extend("password", {
  params: ["target"],
  validate: (value, { target }) => {
    if (value.length > 0) {
      if (value === target) {
        return true;
      } else {
        return false;
      }
    } else {
      passwordMatchMessage = "This is a required field";
      return false;
    }
  },
  message: () => `${passwordMatchMessage}`
});
let passwordErrorMessage =
  "must contain minimum 8 characters, 1 lower-case, upper-case, numeral and special character (!@#$%^*-)";
extend("customPassword", {
  message: field => `The ${field} ${passwordErrorMessage}`,
  validate: value => {
    let notTheseChars = /["'?&/<>\s]/;
    let mustContainTheseChars = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#%^*-]).{8,}$/;
    let containsForbiddenChars = notTheseChars.test(value);
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars && !containsForbiddenChars) {
      return true;
    } else {
      if (containsForbiddenChars) {
        passwordErrorMessage =
          'contains forbidden characters: " ' + " ' ? & / < > or space";
      } else {
        passwordErrorMessage =
          "must contain minimum 8 characters, 1 lower-case, upper-case, numeral and special character (!@#$%^*-)";
      }
      return false;
    }
  }
});
let workHoursMessage = "Work hours must be a number";
extend("numeric", {
  message: () => `${workHoursMessage}`,
  validate: value => {
    let mustChar = /^\d*\.?\d*$/;
    let containsRequiredChars = mustChar.test(value);
    if (containsRequiredChars) {
      if (value < 2) {
        workHoursMessage = "Work Hours must be 2 or more";
        return false;
      } else if (value > 99) {
        workHoursMessage = "Work Hours must be 99 or less";
        return false;
      } else {
        workHoursMessage = "Work hours must be a number";
        return true;
      }
    } else {
      return false;
    }
  }
});
extend("email", {});
export default {
  name: "ProfileSettings",
  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect
  },
  data() {
    return {
      ACCEPTED_IMAGE_FILE_TYPES,
      tokenError: false,
      selectedCountry: {},
      assistantProfileId: "",
      totalApiCalls: [],
      max: moment.utc().format("YYYY-MM-DD"),
      passedApiCalls: [],
      roleName: "",
      files: [],
      alertMessage: "",
      variant: "",
      alertDuration: null,
      initialState: "",
      showAlert: false,
      avatarName: "",
      avatar: "",
      pageLoading: false,
      firstName: "",
      lastName: "",
      email: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      selectedCity: null,
      userId: "",
      streetNumber: "",
      streetName: "",
      cropperLoading: false,
      showCropper: false,
      postalCode: "",
      workHours: "",
      selectedEmploymentType: null,
      doj: "",
      assistantID: "",
      selectedProfileType: null,
      showEmploymenterror: false,
      showPasswordError: false,
      showName: false,
      addressId: "",
      showAddress: false,
      showPassword: false,
      showEmployment: false,
      showCommunications: false,
      specialities: "",
      emailSecondary: "",
      profileID: "",
      slackUserName: "",
      patchOrPostCommunication: false,
      patchOrPostNotification: false,
      patchOrPostAddress: false,
      oldPasswordFilled: false,
      loading: true,
      zoomUserName: "",
      gmailAddress: "",
      photoUpdated: true,
      photoTokenError: false,
      photoFileTypeError: false,
      phoneNumber: "",
      communicationsList: [],
      communicationsListTwo: [],
      notificationsList: [],
      showValidity: false,
      notificationsListTwo: [],
      selectedFile: null,
      cropper: null,
      fileURL: null,
      canvas: null,
      id: "",
      image: null,
      debouncedUpdatePreview: _.debounce(this.updatePreview, 257),
      employmentTypes: [
        { value: null, text: "Select employment type" },
        { value: "FULL", text: "Full Time Employee" },
        { value: "PART", text: "Part Time Employee" }
      ],
      availabilityDays: [
        { value: "MON", text: "Monday", id: 0 },
        { value: "TUE", text: "Tuesday", id: 1 },
        { value: "WED", text: "Wednesday", id: 2 },
        { value: "THUR", text: "Thursday", id: 3 },
        { value: "FRI", text: "Friday", id: 4 },
        { value: "SAT", text: "Saturday", id: 5 },
        { value: "SUN", text: "Sunday", id: 6 }
      ],
      selectedDays: [],
      errorAccountSetting: [],
      errorEmploymentSetting: [],
      errorAddressInfo: []
    };
  },
  methods: {
    ...mapActions("authModule", ["actionGetUserDetails"]),
    getSelectedCountry(selected) {
      this.selectedCountry = selected.text;
    },
    ellipsify,
    routeForward() {
      this.pageLoading = false;
    },
    updatePhoto() {
      this.actionGetUserDetails()
        .then(() => {})
        .catch(err => {
          console.log(err);
        });
    },
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },
    resetModal() {
      this.fileURL = "";
      this.showCropper = false;
      this.selectedFile = null;
    },
    blobToFile(theBlob, fileName) {
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    submitImage() {
      this.photoTokenError = false;
      if (this.canvas) {
        this.cropperLoading = true;
        this.canvas.toBlob(blob => {
          if (blob) {
            let myFile = new File([blob], "avatar.png");
            const formData = new FormData();
            formData.append("avatar", myFile);
            patchAvatar(this.profileID, formData, this.roleName)
              .then(res => {
                this.showCropper = false;
                this.updatePhoto();
                this.avatar = res.data.avatarThumbnail;
                this.photoUpdated = true;
                this.image = null;
              })
              .catch(err => {
                this.showCropper = false;
                if (err.response.status === 401) {
                  this.photoTokenError = true;
                }
              })
              .finally(() => {
                this.cropperLoading = false;
              });
          }
        });
      }
    },
    saveCommunications() {
      const ProfileID = this.profileID;
      const data = this.communicationsList.map(item => ({
        communication: item.id,
        value: item.value || ""
      }));
      this.pageLoading = true;
      postCommunications(ProfileID, data, this.communicationApiRole())
        .then(() => {})
        .catch(err => {
          if (err.response.status === 401) {
            this.tokenError = true;
          }
          this.pageLoading = false;
        });
    },

    patchCommunications() {
      const ProfileID = this.profileID;
      const data = [];
      for (let i = 0; i < this.communicationsListTwo.length; i++) {
        data.push({
          id: this.communicationsListTwo[i].id,
          value: this.communicationsListTwo[i].value
        });
      }
      patchCommunications(ProfileID, data, this.communicationApiRole())
        .then(() => {
          this.alertDuration = 2;
          this.variant = "success";
          this.passedApiCalls.push(true);
          this.pageLoading = true;
          this.showCommunications = true;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.tokenError = true;
          }
          this.pageLoading = false;
          this.showCommunications = true;
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    setNotifications() {
      const data = [];
      for (let i = 0; i < this.notificationsListTwo.length; i++) {
        data.push({
          id: this.notificationsListTwo[i].id,
          isSelected: this.notificationsListTwo[i].isSelected
        });
      }
      patchNotifications(this.profileID, data)
        .then(() => {
          this.passedApiCalls.push(true);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.tokenError = true;
          }
          this.pageLoading = false;
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    saveEmploymentSettings() {
      let days = [...this.selectedDays];
      const data = {
        startDate: this.doj,
        endDate: this.doj,
        workHours: this.workHours,
        specialities: this.specialities,
        employment: this.selectedEmploymentType,
        selectedDays: { days }
      };
      postEmploymentSettings(this.profileID, this.assistantID, data)
        .then(() => {
          this.alertDuration = 2;
          this.showEmployment = true;
          this.passedApiCalls.push(true);
          this.pageLoading = true;
        })
        .catch(err => {
          this.showEmploymenterror = true;
          this.showEmployment = true;
          if (err.response.status === 401) {
            this.tokenError = true;
          } else {
            this.errorEmploymentSetting = [...err.response.data.workHours];
          }
          this.pageLoading = false;
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    changePassword() {
      const data = {
        oldPassword: this.oldPassword,
        newPassword1: this.newPassword,
        newPassword2: this.confirmPassword
      };
      changePassword(data)
        .then(() => {
          this.passedApiCalls.push(true);
          this.confirmPassword = "";
          this.oldPassword = "";
          this.newPassword = "";
          this.$refs.accountSettings.reset();
          this.pageLoading = true;
          this.alertDuration = 2;
          this.showPassword = true;
          this.variant = "success";
          this.alertMessage = "Profile saved";
        })
        .catch(err => {
          this.showPasswordError = true;
          this.showPassword = true;
          this.confirmPassword = "";
          this.oldPassword = "";
          this.pageLoading = false;
          this.newPassword = "";
          this.$refs.accountSettings.reset();
          if (err.response.data.newPassword2 && err.response.data.oldPassword) {
            this.errorAccountSetting = err.response.data.oldPassword.concat(
              err.response.data.newPassword2
            );
          } else if (err.response.data.oldPassword) {
            this.errorAccountSetting = err.response.data.oldPassword;
          } else {
            this.errorAccountSetting = err.response.data.newPassword2;
          }
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    saveAddress() {
      const address = {
        streetNumber: this.streetNumber,
        streetName: this.streetName
      };
      const data = {
        city: this.selectedCity,
        country: this.selectedCountry.text,
        address: address,
        postalCode: this.postalCode
      };
      postAddress(this.profileID, data, this.roleName)
        .then(() => {
          this.alertDuration = 2;
          this.passedApiCalls.push(true);
          this.showAddress = true;
          this.pageLoading = true;
          this.variant = "success";
          this.alertMessage = "Profile saved";
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.tokenError = true;
          }
          this.showAddress = true;
          this.pageLoading = false;
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    patchAddress() {
      const address = {
        streetNumber: this.streetNumber,
        streetName: this.streetName
      };
      const data = {
        city: this.selectedCity,
        country: this.selectedCountry.text,
        address: address,
        postalCode: this.postalCode
      };
      patchAddress(this.profileID, data, this.addressId, this.roleName)
        .then(() => {
          this.alertDuration = 2;
          this.passedApiCalls.push(true);
          this.showAddress = true;
          this.pageLoading = true;
          this.variant = "success";
          this.alertMessage = "Profile saved";
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.tokenError = true;
          }
          this.showAddress = true;
          this.pageLoading = false;
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    saveName() {
      const data = {
        firstName: this.firstName,
        lastName: this.lastName
      };
      postName(this.profileID, this.userId, data, this.roleName)
        .then(() => {
          this.alertDuration = 2;
          this.passedApiCalls.push(true);
          this.showName = true;
          this.pageLoading = true;
          this.variant = "success";
          this.alertMessage = "Profile saved";
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.tokenError = true;
          }
          this.showName = true;
          this.pageLoading = false;
        })
        .finally(() => {
          this.totalApiCalls.push(true);
          this.routeForward();
        });
    },

    async saveAll() {
      this.totalApiCalls = [];
      this.passedApiCalls = [];
      this.showValidity = false;
      this.photoUpdated = true;
      this.showEmploymenterror = false;
      this.showPasswordError = false;
      let communicationInfoValid = await this.$refs.communicationInfo.validate();
      let generalInfoValid = await this.$refs.generalInfo.validate();
      let addressInfoValid = await this.$refs.addressInfo.validate();
      let employmentSettingsValid = true;
      let photoNew = this.avatar !== null ? true : false;
      if (this.role === "assistant") {
        employmentSettingsValid = await this.$refs.employmentSettings.validate();
      }
      let accountSettingsValid = true;
      if (this.oldPassword.length > 0) {
        accountSettingsValid = await this.$refs.accountSettings.validate();
      }
      if (
        communicationInfoValid &&
        generalInfoValid &&
        addressInfoValid &&
        employmentSettingsValid &&
        accountSettingsValid &&
        photoNew
      ) {
        this.pageLoading = true;
        this.saveName();
        if (this.patchOrPostAddress) {
          this.saveAddress();
        } else {
          this.patchAddress();
        }
        if (this.role === "assistant") {
          this.saveEmploymentSettings();
        }
        if (this.oldPassword.length > 0) {
          this.changePassword();
        } else {
          this.totalApiCalls.push(true);
          this.passedApiCalls.push(true);
        }
        if (this.patchOrPostCommunication) {
          this.saveCommunications();
        } else {
          this.patchCommunications();
        }
        if (this.role !== "owner") {
          this.setNotifications();
        }
      } else {
        this.showValidity = true;
        if (!photoNew) {
          this.photoUpdated = false;
        } else {
          this.photoUpdated = true;
        }
      }
    },

    uploadClear(event) {
      event.target.value = "";
      this.photoFileTypeError = false;
    },

    uploadFile(event) {
      const extensions = this.ACCEPTED_IMAGE_FILE_TYPES.split(",").filter(
        item => item[0] === "."
      );

      this.selectedFile = event.target.files[0];

      const fileExtension = `.${
        this.selectedFile.name.split(".").reverse()[0]
      }`;
      const isRestrictedFileType = !extensions.includes(fileExtension);
      if (isRestrictedFileType) {
        this.photoFileTypeError = true;
        event.target.value = "";
        return;
      }

      this.fileURL = URL.createObjectURL(this.selectedFile);
      this.showCropper = true;
      if (this.showCropper) {
        setTimeout(() => {
          this.setupCropperInstance();
        }, 100);
      }
    },

    setupCropperInstance() {
      this.image = this.$refs.source;
      this.cropper = new Cropper(this.image, {
        crop: this.debouncedUpdatePreview,
        autoCropArea: 1,
        aspectRatio: 1,
        viewMode: 0,
        scalable: false,
        zoomable: false
      });
    },

    updatePreview() {
      this.canvas = this.cropper.getCroppedCanvas();
    },

    communicationApiRole() {
      return this.roleName === "owner" || isOwner() ? "assistant" : this.roleName;
    },
    async loadCommunicationIds() {
      const labels = isOwner()
        ? ["assistant", "all"]
        : ["all", "assistant"];
      for (const label of labels) {
        try {
          const res = await getCommunicationIDs(label);
          if (res.data.results?.length) {
            this.communicationsList = [...res.data.results];
            return;
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    async loadNotificationIds() {
      try {
        const res = await getNotificationIDs(this.role);
        this.notificationsList = [...res.data.results];
      } catch (err) {
        console.log(err);
      }
    },
    async getCommIDs() {
      try {
        const res = await getProfile();
        const promises = [];
        this.roleName = res.data.role;
        this.firstName = res.data.firstName;
        this.lastName = res.data.lastName;
        this.email = res.data.email;
        this.avatar = res.data.avatarThumbnail;
        this.id = res.data.id;
        this.avatarName =
          res.data.firstName?.charAt(0).toUpperCase() +
          res.data.lastName?.charAt(0).toUpperCase();
        this.profileID = res.data.defaultProfile.id;
        this.userId = res.data.id;

        await this.loadCommunicationIds();
        if (!isOwner()) {
          await this.loadNotificationIds();
        }

        if (this.role === "assistant") {
          const promise1 = getEmploymentSettings(res.data.defaultProfile.id)
            .then(employmentRes => {
              let {
                id,
                workHours,
                startDate,
                employment,
                selectedDays,
                specialities
              } = employmentRes.data.results[0];
              this.assistantID = id;
              this.workHours = workHours;
              this.doj = startDate;
              this.selectedEmploymentType = employment;
              this.specialities = specialities;
              if (selectedDays.days.length) {
                this.selectedDays = selectedDays.days;
              }
            })
            .catch(err => console.log(err));
          promises.push(promise1);
        }
        const promise2 = getAddress(res.data.defaultProfile.id, this.roleName)
          .then(addressRes => {
            if (addressRes.data.results.length === 0) {
              this.patchOrPostAddress = true;
            } else {
              this.patchOrPostAddress = false;
              let { city, id, address, postalCode, country } =
                addressRes.data.results[0];
              this.selectedCity = city;
              this.addressId = id;
              this.streetNumber = address.streetNumber;
              this.streetName = address.streetName;
              this.postalCode = postalCode;
              this.selectedCountry = this.countries.find(
                item => item.text === country
              );
            }
          })
          .catch(err => console.log(err));
        promises.push(promise2);
        const apiRole = this.communicationApiRole();
        const promise3 = getCommunications(
          res.data.defaultProfile.id,
          apiRole
        )
          .then(communicationsRes => {
            if (communicationsRes.data.results.length === 0) {
              this.patchOrPostCommunication = true;
              const payloadData = [];
              for (let i = 0; i < this.communicationsList.length; i++) {
                payloadData.push({
                  communication: this.communicationsList[i].id,
                  value: ""
                });
              }
              if (!payloadData.length) {
                return;
              }
              return postCommunications(this.profileID, payloadData, apiRole).then(
                () =>
                  getCommunications(this.profileID, apiRole).then(
                    refreshedRes => {
                      this.patchOrPostCommunication = false;
                      this.communicationsListTwo = [
                        ...refreshedRes.data.results
                      ];
                    }
                  )
              );
            }
            this.patchOrPostCommunication = false;
            this.communicationsListTwo = [...communicationsRes.data.results];
          })
          .catch(err => console.log(err));
        promises.push(promise3);
        const promise4 = isOwner()
          ? Promise.resolve()
          : getNotifications(res.data.defaultProfile.id)
          .then(notificationsRes => {
            if (notificationsRes.data.results.length === 0) {
              this.patchOrPostNotification = true;
              const payloadData = [];
              for (let i = 0; i < this.notificationsList.length; i++) {
                payloadData.push({
                  notification: this.notificationsList[i].id,
                  isSelected: false
                });
              }
              return postNotifications(this.profileID, payloadData).then(() =>
                getNotifications(this.profileID).then(response => {
                  this.notificationsListTwo = [...response.data.results];
                  this.patchOrPostNotification = false;
                })
              );
            }
            this.notificationsListTwo = [...notificationsRes.data.results];
          })
          .catch(err => console.log(err));
        promises.push(promise4);
        await Promise.all(promises);
        this.computeInitialState();
        if (this.role === "assistant") {
          getAssistantDetails(this.profileID)
            .then(assistantRes => {
              this.assistantProfileId = assistantRes.data.profile.id;
            })
            .catch(err => console.log(err));
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    computeInitialState() {
      this.initialState = this.serializeForm();
    },
    serializeForm() {
      let profile = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        communications: this.communicationsListTwo.map(c => c.value),
        workHours: this.workHours,
        selectedEmploymentType: this.selectedEmploymentType,
        doj: this.doj,
        selectedDays: this.selectedDays,
        specialities: this.specialities,
        selectedCountry: this.selectedCountry.id,
        selectedCity: this.selectedCity,
        streetName: this.streetName,
        streetNumber: this.streetNumber,
        postalCode: this.postalCode,
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
        notificationsList: this.notificationsListTwo.map(
          notification => notification.isSelected
        )
      };
      return JSON.stringify(profile, Object.keys(profile).sort());
    },
    onBeforeUnload(event) {
      event.returnValue = "Some dummy value";
    }
  },
  beforeDestroy() {
    this.$store.commit({
      type: "removeUnloadListener",
      onBeforeUnload: this.onBeforeUnload
    });
  },
  beforeRouteLeave,
  watch: {
    dirty(isDirty) {
      const isListenerAttached = this.$store.state.isUnloadListenerAttached;
      if (isDirty && !isListenerAttached) {
        this.$store.commit({
          type: "attachUnloadListener",
          onBeforeUnload: this.onBeforeUnload
        });
      }
      if (!isDirty) {
        this.$store.commit({
          type: "removeUnloadListener",
          onBeforeUnload: this.onBeforeUnload
        });
      }
    },
    passedApiCalls() {
      if (this.totalApiCalls.length === this.passedApiCalls.length) {
        // once the form has been saved, recompute the initial state to check for dirtyness
        this.computeInitialState();
      }
    }
  },
  computed: {
    currentState() {
      if (this.loading) {
        return "";
      }
      let profile = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        communications: this.communicationsListTwo.map(c => c.value),
        workHours: this.workHours,
        selectedEmploymentType: this.selectedEmploymentType,
        doj: this.doj,
        selectedDays: this.selectedDays,
        specialities: this.specialities,
        selectedCountry: this.selectedCountry.id,
        selectedCity: this.selectedCity,
        streetName: this.streetName,
        streetNumber: this.streetNumber,
        postalCode: this.postalCode,
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.confirmPassword,
        notificationsList: this.notificationsListTwo.map(
          notification => notification.isSelected
        )
      };
      return JSON.stringify(profile, Object.keys(profile).sort());
    },
    dirty() {
      return this.initialState !== this.currentState || this.image !== null;
    },
    expectedSaveCallCount() {
      if (this.role === "assistant") {
        return 6;
      }
      if (this.role === "owner") {
        return 4;
      }
      return 5;
    },
    ...mapState("authModule", ["role"])
  },
  created() {
    this.getCommIDs();
    this.countries = countriesListJSON.map(item => {
      return {
        text: item.name,
        id: item.id
      };
    });
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;

<style scoped lang="scss">
.profile-err {
  margin-bottom: -3.5rem;
}
.profile-err-2 {
  margin-bottom: -2rem;
  margin-top: -1rem;
}
.profile-err-3 {
  margin-bottom: -3rem;
}
.notif-checkbox:not(:last-child) {
  margin-bottom: 1.5rem;
}
.notif-checkbox:last-child {
  margin-bottom: 0.5rem;
}
.notif-card-row:first-child {
  margin-top: 1rem !important;
}
.notif-card-body {
  padding: 1rem 0 0 1rem !important;
}
.communications-row:first-child {
  margin-top: 1rem;
}
.communications-row:not(:first-child) {
  margin-top: 1.5rem;
}
.communications-textbox {
  right: 0;
}
.full-bg {
  height: 100% !important;
}
.action-text:hover {
  text-decoration: underline;
}
.general-info-card {
  padding: 1rem;
}
.communication-icons {
  width: 40px !important;
  height: 40px !important;
}
.communication-icons img {
  object-fit: cover;
  width: inherit;
  position: relative;
  bottom: 0rem;
}
.assistant-avatar-fallback-grid {
  width: 100%;
  height: auto;
}
.assistant-avatar-fallback-grid-noavatar {
  width: 96px;
  height: 96px;
}
.btn-cancel {
  margin-left: 2rem;
}
.custom-alert {
  margin-bottom: 0;
  padding-bottom: 3rem !important;
  p {
    margin-bottom: 0;
  }
}
.save-button-row {
  padding-bottom: 3rem;
}
</style>
